const SHOW_TOAST = 'SHOW_TOAST';
const HIDE_TOAST = 'HIDE_TOAST';

export default {
	SHOW_TOAST,
	HIDE_TOAST
};
